import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
    selector: 'app-amend-order-thank-you-page',
    templateUrl: './amend-order-thank-you-page.component.html',
    styleUrl: './amend-order-thank-you-page.component.scss',
    standalone: false
})
export class AmendOrderThankYouPageComponent {
  enablePage: any;
  seasonValue: any;
  isAsAgent:boolean=false;
  thankYouContent: Observable<any> = this.PageParagraphComponent.data$;
  data: any;
  constructor(private userInfoService: UserInfoService, private cdr: ChangeDetectorRef,private router: Router,private cmsService: CmsService,public PageParagraphComponent : CmsComponentData<any>,private contentservice:ContentService) { }
  ngOnInit() {
    this.userInfoService.geteditorderseason().subscribe((seasonValue: any) => {
      this.seasonValue = seasonValue;
      if(this.seasonValue=='' || this.seasonValue==undefined){
        this.seasonValue= localStorage.getItem('editorderseason')
      }
      this.userInfoService.getEnablePage().subscribe((data: any) => {
        this.enablePage = data;
        this.cdr.detectChanges();
      })
    })
    this.thankYouContent.subscribe((res: any) => {
      this.data=res;
    });
    this.isAsAgent = this.userInfoService.checkAsmUser();
  }
  handleOnOrdersClick() {
    const obj = {
      showAmendThankYouPage : false
    }
    this.userInfoService.setEnablePage(obj);
  }
}
